<div class="guides-tab-section"
     [style.flex]="fxFill ? 1 : null">
  <app-tab-bar #tabController
               [associatedInsiderId]="this.associatedInsiderId"
               [tabs]="vm.tabs|async">
  </app-tab-bar>
</div>
